// extracted by mini-css-extract-plugin
module.exports = {"hot-brand-card-skeleton":"style_hot-brand-card-skeleton__Eod9z"};